let fbq = function(v1, v2, v3){
    if (typeof window.fbq !== 'undefined'){
        window.fbq(v1, v2, v3);
    }
}

export default {
    fbq
}